<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="detail-image-view">
    <agile :dots="false" class="image-view" :as-nav-for="asNavFor1" ref="main" @afterChange="moveToThumbnail" v-if="imageList.length > 0">
      <div v-for="(image, index) in imageList" :key="`__KOSIWONS_IMAGE_${index}`" :style="{backgroundImage: `url(${image})`}" class="image-container">
        <!--<img :src="image" />-->
      </div>
      <template slot="prevButton">
        <img src="../../assets/images/prev@3x.png" />
      </template>
      <template slot="nextButton">
        <img src="../../assets/images/next@3x.png" />
      </template>
    </agile>

    <agile class="thumbnails" ref="thumbnails" :as-nav-for="asNavFor2" :options="options2" v-if="imageList.length > 0" :unagile="imageList.length === 1" @afterChange="reloadData('thumbnails')">
      <div class="slide slide-thumbniail" v-for="(image, index) in imageList" :key="index" :class="`slide--${index}`" @click="moveToPage(index)">
        <div class="slide-viewer">
          <img :src="image" @load="thumbnailLoaded"/>
        </div>
      </div>
    </agile>
    <div class="image-view none" v-else>
      <div>
        <img src="../../assets/images/non_thumb.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
  import {VueAgile} from 'vue-agile'

  export default {
    name: 'ImageSliderView',
    components: {
      agile: VueAgile
    },
    props: {
      imageList: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      imageList () {
        if (this.$refs.main) {
          this.$refs.main.goTo(0)
          setTimeout(() => {
            this.$refs.main.reload()
          }, 150)
        }
        if (this.$refs.thumbnails) {
          this.$refs.thumbnails.goTo(0)
          // this.imageLoadedCount = 0
          setTimeout(() => {
            this.$refs.main.reload()
            this.$refs.thumbnails.reload()
          }, 150)
        }
        this.$store.dispatch('setNetworkIndicator', false)
      }
    },
    data () {
      return {
        isLoaded: false,
        asNavFor2: [],
        asNavFor1: [],
        options2: {
          centerMode: true,
          dots: false,
          navButtons: false,
          slidesToShow: 6
        },
        imageLoadedCount: 0
      }
    },
    methods: {
      moveToPage (index) {
        // console.log(this.$refs.thumbnails.hasOwnProperty('goTo'))
        if (this.$refs.thumbnails) {
          this.$refs.thumbnails.goTo(index)
        }
        this.$refs.main.goTo(index)
      },
      moveToThumbnail (event) {
        if (this.$refs.thumbnails) {
          this.$refs.thumbnails.goTo(event.currentSlide)
        }
      },
      thumbnailLoaded () {
        this.imageLoadedCount ++
        if (this.imageLoadedCount === this.imageList.length * 3) {
          this.$refs.thumbnails.reload()
        }
      },
      reloadData (type) {
        if (this.$refs[type]) {
          this.$refs[type].reload()
        }
      }
    },
    mounted () {
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .detail-image-view {
    .image-view {
      background: @black-two;
      .image-container {
        background-size: contain;
        background-repeat: no-repeat no-repeat;
        height: 60rem;
        background-position: center;
      }
      /*img {*/
        /*width: 100%;*/
        /*height: 100%;*/
        /*max-height: 60rem;*/
        /*display: block;*/
        /*object-fit: contain;*/
        /*object-position: center;*/
        /*margin: 0 auto;*/
      /*}*/
      &.none {
        max-width: 100%;
        div, img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .thumbnails {
      padding-top:1.5rem;
      max-height: 12.5rem;
      .slide {
        margin: 0 .7rem;
        max-height: 12.5rem;
        max-width: 18rem;

        .slide-viewer {
          display: block;
          height: 100%;
          width: 100%;
          overflow: hidden;
          position: relative;
          padding-top: 66%;

          img {
            opacity: .5;
            transition: opacity .3s;
            position: absolute;
            margin: auto;
            min-height: 100%;
            min-width: 100%;
            left: -100%;
            right: -100%;
            top: -100%;
            bottom: -100%;
            width: 100%;

            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }
</style>


<style lang="less">
  .detail-image-view {
    .agile__actions {
      top: 50%;
      position: absolute;
      transform: translate(0, -50%);
      width: 100%;
      > button {
        img {
          max-width: 2rem;
          max-height: 4rem;
        }
        background: transparent;
        padding: 0;
        margin: 1rem;
        opacity: .7;
      }
    }
  }
  .thumbnails {
    .agile__slide--active{
      img {
        opacity: 1 !important;
      }
    }
  }
</style>
<style scoped lang="less">
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 768px) {
    .thumbnails {
      display: none;
    }
    .detail-image-view {
      .image-view {
        background: @black-two;
        .image-container {
          max-height: 31.25rem;
          height: 31.25rem;
        }
        &.none {
          max-height: 31.25rem;
          height: 31.25rem;
        }
        /*img {*/
          /**/
        /*}*/
      }
    }
  }
</style>

<style lang="less" scoped>
  /* 아이패드 미니 세로 */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio: 1) {
    .detail-image-view .image-view .image-container {
      max-height: 55rem;
      height: 55rem;
    }
  }
</style>

